import { render } from "./ImportDetailInformationTab.vue?vue&type=template&id=3c19d048&scoped=true"
import script from "./ImportDetailInformationTab.vue?vue&type=script&lang=js"
export * from "./ImportDetailInformationTab.vue?vue&type=script&lang=js"

import "./ImportDetailInformationTab.vue?vue&type=style&index=0&id=3c19d048&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c19d048"]])

export default __exports__